const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api.hoctienbo.com';

export type ApiError = {
  status: number;
  message: string;
  data?: unknown;
};

export async function apiCall<T = unknown>(
  endpoint: string,
  options: {
    method?: string;
    body?: unknown;
    token?: string | null;
  } = {}
): Promise<T> {
  const { method = 'GET', body, token } = options;
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${endpoint}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  let data: unknown = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { error: text };
  }

  if (!res.ok) {
    const err: ApiError = {
      status: res.status,
      message: typeof data === 'object' && data !== null && 'error' in data
        ? String((data as { error: unknown }).error)
        : `Request failed (${res.status})`,
      data,
    };
    throw err;
  }
  return data as T;
}

export const API_BASE = API_URL;
